import Scriba from 'react-scriba';

export class DataDenonciation {

    static _onEnregistrementDenonciation(listeIdContacts, denonciation) {
        let objetDenonciation = {
            "listeIdContacts": listeIdContacts,
            "denonciation": denonciation
        };

        var url = "api/MAJDonnees/EnregistrementDenonciation";
        var paramPost = Scriba.fetch().createParameterPost(objetDenonciation);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionDenonciation(listeIdContacts, denonciation) {
        let objetDenonciation = {
            "listeIdContacts": listeIdContacts,
            "denonciation": denonciation
        };

        var url = "api/MAJDonnees/SuppressionDenonciation";
        var paramPost = Scriba.fetch().createParameterPost(objetDenonciation);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDroitsDenonciation() {
        var url = "api/Droit/ListeDesDroitsFicheDenonciation";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementOperationsDenonciationPourSuppression(loginCompte, listeIdContacts) {
        let objet = {
            "loginCompte": loginCompte,
            "listeIdContacts": listeIdContacts
        };

        var url = "api/Liste/ListeDesOPERATIONSParLoginCompteEtParDenonciationPosee";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementOperationsDenonciationPourAjout(loginCompte) {
        let objet = {
            "loginCompte": loginCompte,
        };

        var url = "api/Liste/ListeDesOPERATIONSParLoginCompteEtPourPoseDeDenonciation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _onRegardeSiExisteDenonciationPourUnAutreCommercialisateurEtPourMoi(idContact, idOperation) {
        let objet = {
            "idContact": idContact,
            "idOperation": idOperation
        };

        var url = "api/Get/RegardeSiExisteDenonciationPourUnAutreCommercialisateurEtPourMoi";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDenonciation(idContact, facteurNbreEnregistrement, recherche, tri, pageIndex, filtreActive) {
        let objet = {
            "idContact": idContact,
            "nbreEnreg": facteurNbreEnregistrement,
            "recherche": recherche,
            "tri": tri,
            "pageIndex": pageIndex,
            "filtreActive": filtreActive
        };
        var url = "api/Liste/ListeDesDENONCIATIONS";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}